import React from 'react';
import ClickableHighlight from 'pctComponents/atoms/ClickableHighlight';
import { MdAssignmentLate, MdInfo } from 'react-icons/md';
import { ReactSVG } from 'react-svg';
import impactEvaluationNotification from 'assets/images/impactEvaluationNotification.svg';
import { HiMiniClipboardDocumentList } from 'react-icons/hi2';
import { BiSolidMessage } from 'react-icons/bi';
export interface NotificationTemplate {
    type: string;
    title: string | React.ReactNode | ((data: any, onClickHighlight?: () => void) => React.ReactNode);
    description: string | React.ReactNode | ((data: any, onClickHighlight?: () => void) => React.ReactNode);
    extraText?: string | React.ReactNode | ((data: any) => React.ReactNode);
    buttonLabel?: string | React.ReactNode | ((data: any) => React.ReactNode);
    position?: 'center' | 'bottom-right' | 'top-right';
    extraContainerStyle?: React.CSSProperties;
    checkboxContainerStyle?: React.CSSProperties;
}

export const NOTIFICATION_TEMPLATES: Record<string, NotificationTemplate> = {
    'impact-evaluation': {
        type: 'impact-evaluation',
        title: <h2>{'Treinamento concluído!'}</h2>,
        description: (data: any, onClickHighlight?: () => void) => (
            <span>
                Em {data.availableAfterDays} {data.availableAfterDays === 1 ? 'dia' : 'dias'}, você deverá responder uma <b>Avaliação de Impacto</b> sobre este treinamento. 
                O questionário ficará disponível na área{' '}<ClickableHighlight onClick={onClickHighlight}>Avaliações de impacto</ClickableHighlight>, acessível pelo <b>menu lateral</b>.
            </span>
        ),
        extraText: 'Fique atento ao prazo!',
        buttonLabel: 'Ok entendi',
        position: 'bottom-right',
    },

    'pending-impact-evaluation': {
        type: 'pending-impact-evaluation',
        title: (data: any, onClickHighlight?: () => void) => (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <ReactSVG
                    beforeInjection={(svg) => {
                        svg.style.width = '42px';
                        svg.style.height = '42px';
                        svg.style.fill = 'var(--primary-color)';
                        const fillElements = svg.querySelectorAll('[fill]');
                        fillElements.forEach((el) => {
                            if (el.getAttribute('fill') !== 'none') {
                                el.setAttribute('fill', 'var(--primary-color)');
                            }
                        });
                    }}
                    style={{
                        color: 'var(--primary-color)',
                    }}
                    src={impactEvaluationNotification}
                    alt="impact-evaluation"
                />
                <span>
                    Você pode ter uma ou mais <b>Avaliações de Impacto</b> disponíveis para responder. Acesse-as na área{' '}
                    <ClickableHighlight onClick={onClickHighlight}>Avaliações de Impacto</ClickableHighlight> pelo <b>menu lateral</b>.
                </span>
            </div>
        ),
        extraContainerStyle: {
            width: 527,
        },
        checkboxContainerStyle: {
            marginLeft: 54,
        },
        description: null,
        buttonLabel: 'Ok entendi',
        position: 'bottom-right',
    },

    'certificate-available': {
        type: 'certificate-available',
        title: (data: any) => `Certificado disponível!`,
        description: (data: any, onClickHighlight?: () => void) => (
            <span>
                Parabéns! Você concluiu com sucesso o treinamento <strong>{data.trainingTitle}</strong>. Seu certificado
                já está disponível na área{' '}
                <ClickableHighlight onClick={onClickHighlight}>Meus certificados</ClickableHighlight>, dentro da
                plataforma.
            </span>
        ),
        extraText: (data: any) => `Certificado válido por {data.validityPeriod || 'tempo indeterminado'}.`,
        buttonLabel: 'Ver certificado',
        position: 'center',
    },

    'survey-available': {
        type: 'survey-available',
        title: 'Pesquisa de satisfação',
        description: (data: any) => (
            <span>
                Ajude-nos a melhorar! Responda nossa pesquisa de satisfação sobre o treinamento
                <strong> {data.trainingTitle}</strong>.
                <br />
                <br />A pesquisa estará disponível por {data.daysToComplete} dias e levará apenas alguns minutos.
            </span>
        ),
        extraText: 'Sua opinião é muito importante para nós!',
        buttonLabel: 'Responder agora',
        position: 'bottom-right',
    },
    'required-consumption-interaction': {
        type: 'required-consumption-interaction',
        title: (data: any) => (
            <div
                style={{
                    display: 'flex',
                    gap: '6px',

                    alignItems: 'center',
                    fontSize: '20px',
                }}
            >
                <MdInfo style={{ fontSize: '20px' }} />
                <div style={{ fontSize: '20px', flex: 1 }}>{data.title}</div>
            </div>
        ),
        description: (data: any, onClickHighlight?: () => void) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                <span>
                    Se atente aos{' '}
                    <span style={{ fontWeight: 'bold', color: 'var(--primary-color)' }}>itens obrigatórios</span> que
                    você deve consumir para{' '}
                    <span style={{ fontWeight: 'bold', color: 'var(--primary-color)' }}>conclusão do treinamento.</span>
                </span>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <span
                        style={{
                            display: 'flex',
                            gap: '0.5rem',
                            alignItems: 'center',
                            fontSize: '14px',
                            lineHeight: '16px',
                            fontFamily: 'SF Pro Text',
                        }}
                    >
                        <HiMiniClipboardDocumentList />
                        <span style={{ fontSize: '14px', lineHeight: '16px', fontFamily: 'SF Pro Text' }}>
                            Conteúdos e avaliações indicados com um{' '}
                            <span style={{ fontWeight: 'bold', color: 'var(--primary-color)' }}>asterisco (*)</span>{' '}
                        </span>
                    </span>
                    <span
                        style={{
                            display: 'flex',
                            gap: '0.5rem',
                            alignItems: 'center',
                        }}
                    >
                        <BiSolidMessage />
                        <span style={{ fontSize: '14px', lineHeight: '16px', fontFamily: 'SF Pro Text' }}>
                            <span style={{ fontWeight: 'bold', color: 'var(--primary-color)' }}>Interação</span>{' '}
                            obrigatória{' '}
                        </span>
                    </span>
                </div>
            </div>
        ),
        position: 'top-right',
        buttonLabel: 'Entendi',
    },

    custom: {
        type: 'custom',
        title: (data: any) => data.title || 'Notificação',
        description: (data: any) => data.description || 'Mensagem personalizada',
        extraText: (data: any) => data.extraText,
        buttonLabel: (data: any) => data.buttonLabel || 'OK',
        position: 'center',
    },
};

export const renderNotificationTemplate = (
    template: NotificationTemplate,
    data: any,
    onClickHighlight?: () => void,
) => {
    const getValue = (value: any, passHighlightHandler = false) => {
        if (typeof value === 'function') {
            return passHighlightHandler ? value(data, onClickHighlight) : value(data);
        }
        return value;
    };

    return {
        title: getValue(template.title),
        description: getValue(template.description, true),
        extraText: getValue(template.extraText),
        buttonLabel: getValue(template.buttonLabel),
        position: template.position,
        extraContainerStyle: template.extraContainerStyle,
        checkboxContainerStyle: template.checkboxContainerStyle,
    };
};

export default NOTIFICATION_TEMPLATES;
